module.exports = __webpack_public_path__ + "static/img/play-store.c638e26.png";